import React from 'react'
import { useAppSelector } from '../../../../../hooks/redux'
import { Divider, useTheme } from '@mui/material'

import MediaAvatar from '../../../../atoms/MediaAvatar'

import { selectPresence } from '../../../../../slices/presence'
import { useBreakpoint } from '../../../../../providers/BreakpointProvider'
import useStyles from './styles'

const PeerChatBeginning = ({ name, user }) => {
  const theme = useTheme()

  const { presence } = useAppSelector(selectPresence)

  const { isSmall } = useBreakpoint()

  const [pres, setPres] = React.useState(false)

  const classes = useStyles({ smallMedia: isSmall, pres })

  React.useEffect(() => {
    if (user) {
      const status = presence[user.id]
      setPres(status)
    }
  }, [user, presence])

  return (
    <div className={classes.container}>
      <div className={classes.avatarArea}>
        <MediaAvatar user={user} showBadge />
        <span className={classes.avatarName}>{name}</span>
      </div>

      <div className={classes.message}>
        This is the beginning of the conversation between you and{' '}
        {<span style={{ fontWeight: theme.bold.bold }}>{name}</span>}. This is a
        private conversation between both of you and no one else can read or
        join.
      </div>
      <Divider />
    </div>
  )
}

export default PeerChatBeginning
